import { AfterContentInit, Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormControl, ValidatorFn, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { IBGNProcess } from 'src/app/domain/IBGN/IBGN-process';
import { LongueurStation } from 'src/app/domain/IBGN/longueur-station';
import { EInterventionType } from 'src/app/domain/planning/enum/intervention-type';
import { ENavigationRoute } from 'src/app/models/enum/navigation-route';
import { ENavigationErrorType } from 'src/app/models/navigation-error-type';
import { SpeedDialFabModel } from 'src/app/models/speed-dial-fab.model';
import { IBGNService } from 'src/app/services/ibgn.service';
import { ChangeNavigationService } from 'src/app/tools/change-navigation-service';
import { CoreData } from 'src/app/tools/core-data';
import { NotificationManager } from 'src/app/tools/notification-manager';
import { IbgnMeasureBoxComponent } from 'src/app/tools/ui/ibgn-measure-box/ibgn-measure-box.component';

@Component({
    selector: 'app-ibgn',
    templateUrl: './ibgn.component.html',
    styleUrls: ['./ibgn.component.scss']
})
export class IBGNComponent implements OnInit, AfterContentInit {

    public COMMENT_MAX_SIZE = 100;
    private MESURE_MAX = 5;
    IsAmontX2FarControl = new UntypedFormControl('', Validators.compose([
        this.checkXAgainstAval(),
        Validators.pattern(/^(\d{6})?$/)]));
    IsAvalX2FarControl = new UntypedFormControl('', Validators.compose([
        this.checkXAgainstAmont(),
        Validators.pattern(/^(\d{6})?$/)]));

    IsAmontY2FarControl = new UntypedFormControl('', Validators.compose([
        this.checkYAgainstAval(),
        Validators.pattern(/^(\d{7})?$/)]));
    IsAvalY2FarControl = new UntypedFormControl('', Validators.compose([
        this.checkYAgainstAmont(),
        Validators.pattern(/^(\d{7})?$/)]));
    ValidAmontMaxLength = new UntypedFormControl('', [Validators.maxLength(this.COMMENT_MAX_SIZE)]);
    ValidAvalMaxLength = new UntypedFormControl('', [Validators.maxLength(this.COMMENT_MAX_SIZE)]);

    public model: IBGNProcess = new IBGNProcess();
    private interventionType: EInterventionType;

    public FabOptions: SpeedDialFabModel[] =
        [
            {
                Id: 0,
                Text: undefined,
                Icon: 'save'
            },
            // {
            //     Id: 1,
            //     Text: undefined,
            //     Icon: 'insert_chart_outlined'
            // }
        ];
    constructor(
        private ChangeNavigationService: ChangeNavigationService,
        private coreData: CoreData,
        private iBGNService: IBGNService,
        private snackBar: MatSnackBar,
        private router: Router,
        private dialog: MatDialog,
        private route: ActivatedRoute) {
        this.ChangeNavigationService.NavigationUsedEmitter.subscribe(x => {
            if (x) {
                // this.save(true);
            }
        })
    }

    ngOnInit() {
        if (!this.route.snapshot.params.processCode) {
            this.router.navigate([ENavigationRoute.Error, { type: ENavigationErrorType.URL }]);
            return;
        }

        this.interventionType = Number(this.route.snapshot.params.type) as EInterventionType;
        this.model.Code = this.route.snapshot.params.processCode;
    }

    ngAfterContentInit(): void {
        if (this.coreData.IsOffline) {
            this.model = this.coreData.getOfflineProcess(this.route.snapshot.params.processCode) as IBGNProcess;
        } else {
            this.iBGNService.getStation(this.model.Code).subscribe(x => {
                this.model.LocalisationStation = x.LocalisationStation;
                this.model.MesureStation = x.MesureStation;
            });
        }
        this.ValidAmontMaxLength.markAsTouched();
        this.ValidAvalMaxLength.markAsTouched();
        this.IsAmontX2FarControl.markAsTouched();
        this.IsAvalX2FarControl.markAsTouched();
        this.IsAmontY2FarControl.markAsTouched();
        this.IsAvalY2FarControl.markAsTouched();
    }

    onAmontXKeyUpEvent($event) {
        this.IsAvalX2FarControl.updateValueAndValidity();
    }
    onAvalXKeyUpEvent($event) {
        this.IsAmontX2FarControl.updateValueAndValidity();
    }
    onAmontYKeyUpEvent($event) {
        this.IsAvalY2FarControl.updateValueAndValidity();
    }
    onAvalYKeyUpEvent($event) {
        this.IsAmontY2FarControl.updateValueAndValidity();
    }

    CanSave() {
        return this.model.MesureStation.LtReelle > 0 && this.model.MesureStation.LongueurStations.every(x => x.Longueur > 0);
    }

    checkXAgainstAmont(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null =>
            this.model && this.model.LocalisationStation &&
                !(Math.abs(control.value - this.IsAmontX2FarControl.value) > 500)
                ? null : { wrongColor: control.value };
    }

    checkXAgainstAval(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null =>
            this.model && this.model.LocalisationStation &&
                !(Math.abs(control.value - this.IsAvalX2FarControl.value) > 500)
                ? null : { wrongColor: control.value };
    }

    checkYAgainstAmont(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null =>
            this.model && this.model.LocalisationStation &&
                !(Math.abs(control.value - this.IsAmontY2FarControl.value) > 500)
                ? null : { wrongColor: control.value };
    }

    checkYAgainstAval(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null =>
            this.model && this.model.LocalisationStation &&
                !(Math.abs(control.value - this.IsAvalY2FarControl.value) > 500)
                ? null : { wrongColor: control.value };
    }
    removeMeasure(measure: LongueurStation) {
        // if (this.model.MesureStation.LongueurStations.length > 1) {
        //   this.model.MesureStation.LongueurStations.pop();
        // }
        _.remove(this.model.MesureStation.LongueurStations, x => x === measure);
    }

    openMesureBox(longueur?: LongueurStation) {
        if (this.model.MesureStation.LongueurStations.length >= this.MESURE_MAX) {
            NotificationManager.handleWarning(`Le nombre maximal de mesure est de ${this.MESURE_MAX}`, this.snackBar);
            return;
        }

        const dialogRef = this.dialog.open(IbgnMeasureBoxComponent, {
            data: Object.assign({}, longueur) ?? new LongueurStation(),
            width: '333px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: LongueurStation) => {
            if (result) {
                if (!longueur) {
                    this.model.MesureStation.LongueurStations.push(result);
                } else {
                    Object.assign(longueur, result);
                }
            }
        });
    }

    getLongueurName(i: number) {
        return `L${i + 1}`;
    }

    computeLmMoy() {
        if (this.model.MesureStation.LongueurStations.filter(y => y.Longueur > 0).length === 0) {
            return 0;
        }
        return _.sum(this.model.MesureStation.LongueurStations.map(x => x.Longueur)) / this.model.MesureStation.LongueurStations.filter(y => y.Longueur > 0).length;
    }

    computeLtTheo() {
        return this.computeLmMoy() * 10;
    }

    save(forced: boolean) {
        if (!this.CanSave() && !forced) {
            NotificationManager.handleError('Les données ne sont pas valides', this.snackBar);
            return;
        }
        if (this.coreData.IsOffline) {
            this.coreData.setOfflineProcess(this.model);
        } else {
            this.iBGNService.updateStation(this.model).subscribe(x => {
                NotificationManager.handleSuccess('Intervention enregistrée', this.snackBar);
            });
        }
    }

    dispatch(event: SpeedDialFabModel) {

        switch (event.Id) {
            case 0:
                this.save(false);
                break;
            // case 1:
            //     this.router.navigate([ENavigationRoute.PlanPrelevement, { processCode: this.model.Code, type: this.interventionType }]);
            //     break;
        }
    }
}
